import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import _ from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { logger } from '../utils/helper';
import { selectAccessToken } from './authSlice';
export const initialUser = {
  id: '',
  loading: true,
};

const slice = createSlice({
  name: 'user',
  initialState: initialUser,
  reducers: {
    changeUser(state, action: PayloadAction<any>) {
      _.keys(action.payload).forEach(key => {
        _.set(state, key, action.payload[key]);
      });
    },
    initUser(state) {
      _.keys(state).forEach(key => {
        _.set(state, key, null);
      });
    },
  },
});

export const { actions: userActions, reducer: userReducer } = slice;

const selectDomain = (state: { user: any }) => state.user || initialUser;

export const userSelector = createSelector(
  [selectDomain],
  userState => userState,
);

function getGetUserMe(accessToken: any) {
  return axios({
    method: 'GET',
    url: '/api/v1/user/who-am-i',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
}

export const REFRESH_USER_SAGA = 'REFRESH_USER_SAGA';
export function* refreshUserSaga(): Generator<any, void, any> {
  try {
    yield put(userActions.changeUser({ loading: true }));
    const accessToken = yield select(selectAccessToken);

    const token = accessToken;
    if (!token) {
      logger.log('NO TOKEN');
      return;
    }

    yield getUser(token);
  } catch (err) {
    const action = userActions.changeUser(initialUser);
    logger.log('USER REFRESH INIT', err, action);
    yield put(action);
  } finally {
    const action = userActions.changeUser({ loading: false });
    yield put(action);
  }
}

export function* getUser(token: any): Generator<any, void, any> {
  const userRes = yield call(getGetUserMe, token);
  const userData = _.get(userRes, 'data');
  const userAction = userActions.changeUser(userData);
  yield put(userAction);
}
